import { DialogContentText } from '@mui/material';

import { AppDialog } from 'components/Dialogs';
import strings from 'constants/index';

interface DuplicateEntityReplacedDialogProps {
  isOpen: boolean;
  onHide: () => void;
  duplicateId: string;
  originalId: string;
}

export const DuplicateEntityReplacedDialog = ({
  isOpen,
  onHide,
  duplicateId,
  originalId,
}: DuplicateEntityReplacedDialogProps) => {
  const message = `Your entity ${duplicateId} was previously identified as a duplicate to ${originalId}, therefore it was internally replaced with the original entity.`;

  return (
    <AppDialog
      open={isOpen}
      title={strings.information}
      onClose={onHide}
      confirmButton={{
        label: strings.ok,
        props: { onClick: onHide },
      }}
    >
      <DialogContentText>{message}</DialogContentText>
    </AppDialog>
  );
};
